 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_FOULDEEDS_FRONTCOVER from '@/components/01_Fouldeeds_frontcover'
 import A2_FOULDEEDS_FRONT from '@/components/02_Fouldeeds_front'
 import A3_FOULDEEDS_TITLEPAGE from '@/components/03_Fouldeeds_titlepage'
 import A4_FOULDEEDS_DEDICATION from '@/components/04_Fouldeeds_dedication'
 import A5_FOULDEEDS_COPYRIGHT from '@/components/05_Fouldeeds_copyright'
 import A6_FOULDEEDS_CONTENTS from '@/components/06_Fouldeeds_contents'
 import A6A_FOULDEEDS_CONTENTS1 from '@/components/06a_Fouldeeds_contents1'
 import A6A_FOULDEEDS_INTRODUCTION from '@/components/06a_Fouldeeds_introduction'
 import A6B_FOULDEEDS_INTRODUCTION1 from '@/components/06b_Fouldeeds_introduction1'
 import A7_FOULDEEDS_ACK from '@/components/07_Fouldeeds_ack'
 import A7A_FOULDEEDS_ACK1 from '@/components/07a_Fouldeeds_ack1'
 import A8_FOULDEEDS_CH01 from '@/components/08_Fouldeeds_ch01'
 import A8A_FOULDEEDS_CH011 from '@/components/08a_Fouldeeds_ch011'
 import A8A_FOULDEEDS_CH012 from '@/components/08a_Fouldeeds_ch012'
 import A8A_FOULDEEDS_CH013 from '@/components/08a_Fouldeeds_ch013'
 import A8A_FOULDEEDS_CH014 from '@/components/08a_Fouldeeds_ch014'
 import A8A_FOULDEEDS_CH015 from '@/components/08a_Fouldeeds_ch015'
 import A8A_FOULDEEDS_CH016 from '@/components/08a_Fouldeeds_ch016'
 import A8A_FOULDEEDS_CH017 from '@/components/08a_Fouldeeds_ch017'
 import A8A_FOULDEEDS_CH018 from '@/components/08a_Fouldeeds_ch018'
 import A8A_FOULDEEDS_CH019 from '@/components/08a_Fouldeeds_ch019'
 import A8A_FOULDEEDS_CH0110 from '@/components/08a_Fouldeeds_ch0110'
 import A8A_FOULDEEDS_CH0111 from '@/components/08a_Fouldeeds_ch0111'
 import A8A_FOULDEEDS_CH0112 from '@/components/08a_Fouldeeds_ch0112'
 import A8A_FOULDEEDS_CH0113 from '@/components/08a_Fouldeeds_ch0113'
 import A8A_FOULDEEDS_CH0114 from '@/components/08a_Fouldeeds_ch0114'
 import A8A_FOULDEEDS_CH0115 from '@/components/08a_Fouldeeds_ch0115'
 import A8A_FOULDEEDS_CH0116 from '@/components/08a_Fouldeeds_ch0116'
 import A8A_FOULDEEDS_CH0117 from '@/components/08a_Fouldeeds_ch0117'
 import A8A_FOULDEEDS_CH0118 from '@/components/08a_Fouldeeds_ch0118'
 import A8A_FOULDEEDS_CH0119 from '@/components/08a_Fouldeeds_ch0119'
 import A8A_FOULDEEDS_CH0120 from '@/components/08a_Fouldeeds_ch0120'
 import A8A_FOULDEEDS_CH0121 from '@/components/08a_Fouldeeds_ch0121'
 import A8A_FOULDEEDS_CH0122 from '@/components/08a_Fouldeeds_ch0122'
 import A8A_FOULDEEDS_CH0123 from '@/components/08a_Fouldeeds_ch0123'
 import A8A_FOULDEEDS_CH0123A from '@/components/08a_Fouldeeds_ch0123a'
 import A8A_FOULDEEDS_CH0124 from '@/components/08a_Fouldeeds_ch0124'
 import A8A_FOULDEEDS_CH0125 from '@/components/08a_Fouldeeds_ch0125'
 import A8A_FOULDEEDS_CH0126 from '@/components/08a_Fouldeeds_ch0126'
 import A8A_FOULDEEDS_CH0127 from '@/components/08a_Fouldeeds_ch0127'
 import A8A_FOULDEEDS_CH0128 from '@/components/08a_Fouldeeds_ch0128'
 import A8A_FOULDEEDS_CH0129 from '@/components/08a_Fouldeeds_ch0129'
 import A8A_FOULDEEDS_CH0130 from '@/components/08a_Fouldeeds_ch0130'
 import A8A_FOULDEEDS_CH0131 from '@/components/08a_Fouldeeds_ch0131'
 import A8A_FOULDEEDS_CH0132 from '@/components/08a_Fouldeeds_ch0132'
 import A8A_FOULDEEDS_CH0133 from '@/components/08a_Fouldeeds_ch0133'
 import A8A_FOULDEEDS_CH0134 from '@/components/08a_Fouldeeds_ch0134'
 import A8A_FOULDEEDS_CH0135 from '@/components/08a_Fouldeeds_ch0135'
 import A8A_FOULDEEDS_CH0136 from '@/components/08a_Fouldeeds_ch0136'
 import A8A_FOULDEEDS_CH0137 from '@/components/08a_Fouldeeds_ch0137'
 import A8A_FOULDEEDS_CH0138 from '@/components/08a_Fouldeeds_ch0138'
 import A9_FOULDEEDS_CH02 from '@/components/09_Fouldeeds_ch02'
 import A9A_FOULDEEDS_CH021 from '@/components/09a_Fouldeeds_ch021'
 import A9A_FOULDEEDS_CH021A from '@/components/09a_Fouldeeds_ch021a'
 import A9A_FOULDEEDS_CH022 from '@/components/09a_Fouldeeds_ch022'
 import A9A_FOULDEEDS_CH023 from '@/components/09a_Fouldeeds_ch023'
 import A9A_FOULDEEDS_CH024 from '@/components/09a_Fouldeeds_ch024'
 import A9A_FOULDEEDS_CH025 from '@/components/09a_Fouldeeds_ch025'
 import A9A_FOULDEEDS_CH026 from '@/components/09a_Fouldeeds_ch026'
 import A9A_FOULDEEDS_CH027 from '@/components/09a_Fouldeeds_ch027'
 import A9A_FOULDEEDS_CH028 from '@/components/09a_Fouldeeds_ch028'
 import A9A_FOULDEEDS_CH029 from '@/components/09a_Fouldeeds_ch029'
 import A9A_FOULDEEDS_CH0210 from '@/components/09a_Fouldeeds_ch0210'
 import A9A_FOULDEEDS_CH0211 from '@/components/09a_Fouldeeds_ch0211'
 import A0_FOULDEEDS_CH03 from '@/components/10_Fouldeeds_ch03'
 import A0A_FOULDEEDS_CH031 from '@/components/10a_Fouldeeds_ch031'
 import A0A_FOULDEEDS_CH032 from '@/components/10a_Fouldeeds_ch032'
 import A0A_FOULDEEDS_CH033 from '@/components/10a_Fouldeeds_ch033'
 import A0A_FOULDEEDS_CH034 from '@/components/10a_Fouldeeds_ch034'
 import A0A_FOULDEEDS_CH035 from '@/components/10a_Fouldeeds_ch035'
 import A0A_FOULDEEDS_CH036 from '@/components/10a_Fouldeeds_ch036'
 import A0A_FOULDEEDS_CH037 from '@/components/10a_Fouldeeds_ch037'
 import A0A_FOULDEEDS_CH038 from '@/components/10a_Fouldeeds_ch038'
 import A0A_FOULDEEDS_CH039 from '@/components/10a_Fouldeeds_ch039'
 import A0A_FOULDEEDS_CH0310 from '@/components/10a_Fouldeeds_ch0310'
 import A0A_FOULDEEDS_CH0311 from '@/components/10a_Fouldeeds_ch0311'
 import A0A_FOULDEEDS_CH0312 from '@/components/10a_Fouldeeds_ch0312'
 import A0A_FOULDEEDS_CH0313 from '@/components/10a_Fouldeeds_ch0313'
 import A0A_FOULDEEDS_CH0314 from '@/components/10a_Fouldeeds_ch0314'
 import A0A_FOULDEEDS_CH0315 from '@/components/10a_Fouldeeds_ch0315'
 import A0A_FOULDEEDS_CH0316 from '@/components/10a_Fouldeeds_ch0316'
 import A0A_FOULDEEDS_CH0317 from '@/components/10a_Fouldeeds_ch0317'
 import A0A_FOULDEEDS_CH0318 from '@/components/10a_Fouldeeds_ch0318'
 import A0A_FOULDEEDS_CH0319 from '@/components/10a_Fouldeeds_ch0319'
 import A0A_FOULDEEDS_CH0320 from '@/components/10a_Fouldeeds_ch0320'
 import A0A_FOULDEEDS_CH0321 from '@/components/10a_Fouldeeds_ch0321'
 import A0A_FOULDEEDS_CH0322 from '@/components/10a_Fouldeeds_ch0322'
 import A0A_FOULDEEDS_CH0323 from '@/components/10a_Fouldeeds_ch0323'
 import A0A_FOULDEEDS_CH0324 from '@/components/10a_Fouldeeds_ch0324'
 import A0A_FOULDEEDS_CH0325 from '@/components/10a_Fouldeeds_ch0325'
 import A0A_FOULDEEDS_CH0326 from '@/components/10a_Fouldeeds_ch0326'
 import A0A_FOULDEEDS_CH0327 from '@/components/10a_Fouldeeds_ch0327'
 import A1_FOULDEEDS_CH04 from '@/components/11_Fouldeeds_ch04'
 import A1A_FOULDEEDS_CH041 from '@/components/11a_Fouldeeds_ch041'
 import A1A_FOULDEEDS_CH042 from '@/components/11a_Fouldeeds_ch042'
 import A1A_FOULDEEDS_CH043 from '@/components/11a_Fouldeeds_ch043'
 import A1A_FOULDEEDS_CH044 from '@/components/11a_Fouldeeds_ch044'
 import A1A_FOULDEEDS_CH045 from '@/components/11a_Fouldeeds_ch045'
 import A1A_FOULDEEDS_CH046 from '@/components/11a_Fouldeeds_ch046'
 import A1A_FOULDEEDS_CH047 from '@/components/11a_Fouldeeds_ch047'
 import A1A_FOULDEEDS_CH048 from '@/components/11a_Fouldeeds_ch048'
 import A1A_FOULDEEDS_CH049 from '@/components/11a_Fouldeeds_ch049'
 import A1A_FOULDEEDS_CH0410 from '@/components/11a_Fouldeeds_ch0410'
 import A1A_FOULDEEDS_CH0411 from '@/components/11a_Fouldeeds_ch0411'
 import A1A_FOULDEEDS_CH0412 from '@/components/11a_Fouldeeds_ch0412'
 import A1A_FOULDEEDS_CH0413 from '@/components/11a_Fouldeeds_ch0413'
 import A1A_FOULDEEDS_CH0414 from '@/components/11a_Fouldeeds_ch0414'
 import A1A_FOULDEEDS_CH0415 from '@/components/11a_Fouldeeds_ch0415'
 import A2_FOULDEEDS_CH05 from '@/components/12_Fouldeeds_ch05'
 import A2A_FOULDEEDS_CH051 from '@/components/12a_Fouldeeds_ch051'
 import A2A_FOULDEEDS_CH052 from '@/components/12a_Fouldeeds_ch052'
 import A2A_FOULDEEDS_CH053 from '@/components/12a_Fouldeeds_ch053'
 import A2A_FOULDEEDS_CH054 from '@/components/12a_Fouldeeds_ch054'
 import A2A_FOULDEEDS_CH055 from '@/components/12a_Fouldeeds_ch055'
 import A2A_FOULDEEDS_CH056 from '@/components/12a_Fouldeeds_ch056'
 import A2A_FOULDEEDS_CH057 from '@/components/12a_Fouldeeds_ch057'
 import A3_FOULDEEDS_CH06 from '@/components/13_Fouldeeds_ch06'
 import A3A_FOULDEEDS_CH061 from '@/components/13a_Fouldeeds_ch061'
 import A3A_FOULDEEDS_CH062 from '@/components/13a_Fouldeeds_ch062'
 import A4_FOULDEEDS_CH07 from '@/components/14_Fouldeeds_ch07'
 import A4A_FOULDEEDS_CH071 from '@/components/14a_Fouldeeds_ch071'
 import A4A_FOULDEEDS_CH072 from '@/components/14a_Fouldeeds_ch072'
 import A4A_FOULDEEDS_CH073 from '@/components/14a_Fouldeeds_ch073'
 import A4A_FOULDEEDS_CH074 from '@/components/14a_Fouldeeds_ch074'
 import A4A_FOULDEEDS_CH074A from '@/components/14a_Fouldeeds_ch074a'
 import A4A_FOULDEEDS_CH074B from '@/components/14a_Fouldeeds_ch074b'
 import A4A_FOULDEEDS_CH075 from '@/components/14a_Fouldeeds_ch075'
 import A4A_FOULDEEDS_CH076 from '@/components/14a_Fouldeeds_ch076'
 import A5_FOULDEEDS_CH08 from '@/components/15_Fouldeeds_ch08'
 import A5A_FOULDEEDS_CH081 from '@/components/15a_Fouldeeds_ch081'
 import A5A_FOULDEEDS_CH082 from '@/components/15a_Fouldeeds_ch082'
 import A5A_FOULDEEDS_CH083 from '@/components/15a_Fouldeeds_ch083'
 import A5A_FOULDEEDS_CH084 from '@/components/15a_Fouldeeds_ch084'
 import A5A_FOULDEEDS_CH085 from '@/components/15a_Fouldeeds_ch085'
 import A5A_FOULDEEDS_CH086 from '@/components/15a_Fouldeeds_ch086'
 import A5A_FOULDEEDS_CH087 from '@/components/15a_Fouldeeds_ch087'
 import A5A_FOULDEEDS_CH088 from '@/components/15a_Fouldeeds_ch088'
 import A6_FOULDEEDS_CH09 from '@/components/16_Fouldeeds_ch09'
 import A6A_FOULDEEDS_CH091 from '@/components/16a_Fouldeeds_ch091'
 import A6A_FOULDEEDS_CH092 from '@/components/16a_Fouldeeds_ch092'
 import A7_FOULDEEDS_CH10 from '@/components/17_Fouldeeds_ch10'
 import A7A_FOULDEEDS_CH101 from '@/components/17a_Fouldeeds_ch101'
 import A7A_FOULDEEDS_CH102 from '@/components/17a_Fouldeeds_ch102'
 import A7A_FOULDEEDS_CH103 from '@/components/17a_Fouldeeds_ch103'
 import A7A_FOULDEEDS_CH104 from '@/components/17a_Fouldeeds_ch104'
 import A7A_FOULDEEDS_CH105 from '@/components/17a_Fouldeeds_ch105'
 import A7A_FOULDEEDS_CH106 from '@/components/17a_Fouldeeds_ch106'
 import A7A_FOULDEEDS_CH107 from '@/components/17a_Fouldeeds_ch107'
 import A7A_FOULDEEDS_CH108 from '@/components/17a_Fouldeeds_ch108'
 import A7A_FOULDEEDS_CH109 from '@/components/17a_Fouldeeds_ch109'
 import A8_FOULDEEDS_CH11 from '@/components/18_Fouldeeds_ch11'
 import A8A_FOULDEEDS_CH111 from '@/components/18a_Fouldeeds_ch111'
 import A8A_FOULDEEDS_CH112 from '@/components/18a_Fouldeeds_ch112'
 import A8A_FOULDEEDS_CH113 from '@/components/18a_Fouldeeds_ch113'
 import A8A_FOULDEEDS_CH114 from '@/components/18a_Fouldeeds_ch114'
 import A8A_FOULDEEDS_CH115 from '@/components/18a_Fouldeeds_ch115'
 import A8A_FOULDEEDS_CH116 from '@/components/18a_Fouldeeds_ch116'
 import A8A_FOULDEEDS_CH117 from '@/components/18a_Fouldeeds_ch117'
 import A8A_FOULDEEDS_CH118 from '@/components/18a_Fouldeeds_ch118'
 import A8A_FOULDEEDS_CH119 from '@/components/18a_Fouldeeds_ch119'
 import A8A_FOULDEEDS_CH1110 from '@/components/18a_Fouldeeds_ch1110'
 import A8A_FOULDEEDS_CH1111 from '@/components/18a_Fouldeeds_ch1111'
 import A8A_FOULDEEDS_CH1112 from '@/components/18a_Fouldeeds_ch1112'
 import A8A_FOULDEEDS_CH1113 from '@/components/18a_Fouldeeds_ch1113'
 import A8A_FOULDEEDS_CH1114 from '@/components/18a_Fouldeeds_ch1114'
 import A8A_FOULDEEDS_CH1115 from '@/components/18a_Fouldeeds_ch1115'
 import A8A_FOULDEEDS_CH1116 from '@/components/18a_Fouldeeds_ch1116'
 import A8A_FOULDEEDS_CH1117 from '@/components/18a_Fouldeeds_ch1117'
 import A8A_FOULDEEDS_CH1118 from '@/components/18a_Fouldeeds_ch1118'
 import A8A_FOULDEEDS_CH1119 from '@/components/18a_Fouldeeds_ch1119'
 import A8A_FOULDEEDS_CH1120 from '@/components/18a_Fouldeeds_ch1120'
 import A8A_FOULDEEDS_CH1121 from '@/components/18a_Fouldeeds_ch1121'
 import A8A_FOULDEEDS_CH1122 from '@/components/18a_Fouldeeds_ch1122'
 import A9_FOULDEEDS_CH12 from '@/components/19_Fouldeeds_ch12'
 import A9A_FOULDEEDS_CH121 from '@/components/19a_Fouldeeds_ch121'
 import A9A_FOULDEEDS_CH122 from '@/components/19a_Fouldeeds_ch122'
 import A9A_FOULDEEDS_CH123 from '@/components/19a_Fouldeeds_ch123'
 import A9A_FOULDEEDS_CH124 from '@/components/19a_Fouldeeds_ch124'
 import A9A_FOULDEEDS_CH125 from '@/components/19a_Fouldeeds_ch125'
 import A9A_FOULDEEDS_CH126 from '@/components/19a_Fouldeeds_ch126'
 import A9A_FOULDEEDS_CH127 from '@/components/19a_Fouldeeds_ch127'
 import A9A_FOULDEEDS_CH128 from '@/components/19a_Fouldeeds_ch128'
 import A9A_FOULDEEDS_CH129 from '@/components/19a_Fouldeeds_ch129'
 import A9A_FOULDEEDS_CH1210 from '@/components/19a_Fouldeeds_ch1210'
 import A9A_FOULDEEDS_CH1211 from '@/components/19a_Fouldeeds_ch1211'
 import A0_FOULDEEDS_CH13 from '@/components/20_Fouldeeds_ch13'
 import A0A_FOULDEEDS_CH131 from '@/components/20a_Fouldeeds_ch131'
 import A0A_FOULDEEDS_CH132 from '@/components/20a_Fouldeeds_ch132'
 import A0A_FOULDEEDS_CH133 from '@/components/20a_Fouldeeds_ch133'
 import A0A_FOULDEEDS_CH134 from '@/components/20a_Fouldeeds_ch134'
 import A0A_FOULDEEDS_CH135 from '@/components/20a_Fouldeeds_ch135'
 import A0A_FOULDEEDS_CH136 from '@/components/20a_Fouldeeds_ch136'
 import A0A_FOULDEEDS_CH137 from '@/components/20a_Fouldeeds_ch137'
 import A1_FOULDEEDS_CH14 from '@/components/21_Fouldeeds_ch14'
 import A1A_FOULDEEDS_CH141 from '@/components/21a_Fouldeeds_ch141'
 import A1A_FOULDEEDS_CH142 from '@/components/21a_Fouldeeds_ch142'
 import A1A_FOULDEEDS_CH143 from '@/components/21a_Fouldeeds_ch143'
 import A1A_FOULDEEDS_CH144 from '@/components/21a_Fouldeeds_ch144'
 import A1A_FOULDEEDS_CH145 from '@/components/21a_Fouldeeds_ch145'
 import A1A_FOULDEEDS_CH146 from '@/components/21a_Fouldeeds_ch146'
 import A1A_FOULDEEDS_CH147 from '@/components/21a_Fouldeeds_ch147'
 import A1A_FOULDEEDS_CH148 from '@/components/21a_Fouldeeds_ch148'
 import A1A_FOULDEEDS_CH149 from '@/components/21a_Fouldeeds_ch149'
 import A1A_FOULDEEDS_CH1410 from '@/components/21a_Fouldeeds_ch1410'
 import A1A_FOULDEEDS_CH1411 from '@/components/21a_Fouldeeds_ch1411'
 import A2_FOULDEEDS_SOURCES from '@/components/22_Fouldeeds_Sources'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/06_Fouldeeds_contents",
 			"name" : "06_Fouldeeds_contents",
 			"component" : A6_FOULDEEDS_CONTENTS
 		},
 		{
 			"path" : "/06a_Fouldeeds_contents1",
 			"name" : "06a_Fouldeeds_contents1",
 			"component" : A6A_FOULDEEDS_CONTENTS1
 		},
 		{
 			"path" : "/06a_Fouldeeds_introduction",
 			"name" : "06a_Fouldeeds_introduction",
 			"component" : A6A_FOULDEEDS_INTRODUCTION
 		},
 		{
 			"path" : "/06b_Fouldeeds_introduction1",
 			"name" : "06b_Fouldeeds_introduction1",
 			"component" : A6B_FOULDEEDS_INTRODUCTION1
 		},
 		{
 			"path" : "/07_Fouldeeds_ack",
 			"name" : "07_Fouldeeds_ack",
 			"component" : A7_FOULDEEDS_ACK
 		},
 		{
 			"path" : "/07a_Fouldeeds_ack1",
 			"name" : "07a_Fouldeeds_ack1",
 			"component" : A7A_FOULDEEDS_ACK1
 		},
 		{
 			"path" : "/08_Fouldeeds_ch01",
 			"name" : "08_Fouldeeds_ch01",
 			"component" : A8_FOULDEEDS_CH01
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch011",
 			"name" : "08a_Fouldeeds_ch011",
 			"component" : A8A_FOULDEEDS_CH011
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch012",
 			"name" : "08a_Fouldeeds_ch012",
 			"component" : A8A_FOULDEEDS_CH012
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch013",
 			"name" : "08a_Fouldeeds_ch013",
 			"component" : A8A_FOULDEEDS_CH013
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch014",
 			"name" : "08a_Fouldeeds_ch014",
 			"component" : A8A_FOULDEEDS_CH014
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch015",
 			"name" : "08a_Fouldeeds_ch015",
 			"component" : A8A_FOULDEEDS_CH015
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch016",
 			"name" : "08a_Fouldeeds_ch016",
 			"component" : A8A_FOULDEEDS_CH016
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch017",
 			"name" : "08a_Fouldeeds_ch017",
 			"component" : A8A_FOULDEEDS_CH017
 		},
 		{
 			"path" : "/08a_Fouldeeds_ch018",
 			"name" : "08a_Fouldeeds_ch018",
 			"component" : A8A_FOULDEEDS_CH018
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js